import * as React from 'react';
import { ButtonDropdown } from '@grandvisionhq/common';
import { COLUMNED_DROPDOWN_PLACEHOLDER } from './constants.js';

const SingleColumnDropdown = ({ label , className , options , selectedValue , onChange , isDisabled , isInvalid , isRequired , 'data-t': dataT , id  })=>{
    const optionsArray = Object.entries(options).map(([key, value])=>({
            label: key,
            value
        })
    ).reverse().sort((a, b)=>Number(a.value) - Number(b.value)
    );
    return /*#__PURE__*/ React.createElement(ButtonDropdown, {
        onChange: onChange,
        className: className,
        value: selectedValue,
        "aria-label": label,
        isRequired: isRequired,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        "data-t": dataT
    }, /*#__PURE__*/ React.createElement(ButtonDropdown.Select, {
        id: id,
        placeholder: COLUMNED_DROPDOWN_PLACEHOLDER,
        className: "single-columned-dropdown__select"
    }), /*#__PURE__*/ React.createElement(ButtonDropdown.Content, {
        type: "select",
        className: "single-columned-dropdown__content"
    }, optionsArray.map(({ label: optionLabel , value  })=>/*#__PURE__*/ React.createElement(ButtonDropdown.Option, {
            key: value,
            value: value,
            className: "single-columned-dropdown__option"
        }, optionLabel)
    )));
};

export { SingleColumnDropdown };
//# sourceMappingURL=SingleColumnDropdown.js.map
